module.exports = __webpack_public_path__ + "static/media/fundo-sigUI-wires-v0.2-flow1-demo.19682a05.mp4";